import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "filters" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "file-name ellipsis-cell" }
const _hoisted_4 = { class: "controls" }
const _hoisted_5 = {
  key: 0,
  class: "icon-wrap pointer"
}
const _hoisted_6 = {
  key: 1,
  class: "icon-wrap pointer"
}
const _hoisted_7 = { class: "icon-wrap pointer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Empty = _resolveComponent("Empty")
  const _component_DropdownCheckgroup = _resolveComponent("DropdownCheckgroup")
  const _component_DropdownCalendar = _resolveComponent("DropdownCalendar")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_UploadButton = _resolveComponent("UploadButton")
  const _component_TableHead = _resolveComponent("TableHead")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_Column = _resolveComponent("Column")
  const _component_StatusBadge = _resolveComponent("StatusBadge")
  const _component_TagsGroup = _resolveComponent("TagsGroup")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    items: $props.files,
    total: $props.count,
    loading: $props.loading,
    "sort-field": _ctx.sort_field,
    "sort-order": _ctx.sort_order,
    skip: $props.skip,
    "override-skip": "",
    onPage: $options.onPage,
    onSort: $options.onSort
  }, {
    empty: _withCtx(() => [
      _createVNode(_component_Empty, { bg: "assets/bg-pattern-square.png" }, {
        image: _withCtx(() => [
          _createVNode(_component_Icon, {
            width: "4rem",
            height: "4rem",
            icon: "search",
            class: "icon-svg"
          })
        ]),
        title: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("No shared files were found")
        ])),
        "sub-text": _withCtx(() => [
          ($props.highlight)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Your search “" + _toDisplayString($props.highlight) + "” did not match any shared files. ", 1 /* TEXT */),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* HOISTED */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("a", {
            class: "pointer",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.onReset && $options.onReset(...args)))
          }, "Clear filters")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    "header-left": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DropdownCheckgroup, {
          modelValue: _ctx.filter_exts,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filter_exts) = $event)),
          title: "Type",
          items: $props.allExts
        }, null, 8 /* PROPS */, ["modelValue", "items"]),
        _createVNode(_component_DropdownCheckgroup, {
          modelValue: _ctx.filter_statuses,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filter_statuses) = $event)),
          title: "Status",
          items: $props.allStatuses
        }, null, 8 /* PROPS */, ["modelValue", "items"]),
        _createVNode(_component_DropdownCalendar, {
          modelValue: _ctx.filter_dates,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.filter_dates) = $event)),
          title: "Dates",
          width: "28.5rem"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" TEMPRARLIY disabled, until we support multiple users for one tenant "),
        _createCommentVNode(" Dropdown v-model=\"dd\" :items=\"[]\" :footnote=\"false\" placeholder=\"Uploaded by\"/ "),
        ($options.can_clear)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "clear-filters",
              width: "2rem",
              height: "2rem",
              stroke: "var(--gray-600)",
              onClick: _cache[4] || (_cache[4] = $event => ($options.clearFilters()))
            }, " Clear All "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    "header-right": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SearchInput, {
          ref: "search",
          delay: 1000,
          onSearch: $options.onSearch
        }, null, 8 /* PROPS */, ["onSearch"]),
        ($options.is_admin)
          ? (_openBlock(), _createBlock(_component_UploadButton, {
              key: 0,
              ref: "upload_btn",
              multiple: "",
              type: "icon",
              onUpload: _cache[5] || (_cache[5] = $event => (_ctx.$emit('upload', $event)))
            }, null, 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        class: "name-col",
        style: {"width":"100%"},
        sortable: "",
        "sort-field": "name"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "File name",
            sortable: "",
            "sort-order": sortOrder,
            selected: _ctx.selected.size > 0,
            indeterminate: _ctx.selected.size > 0 && !$options.all_selected,
            disabled: $props.files.length === 0
          }, null, 8 /* PROPS */, ["sort-order", "selected", "indeterminate", "disabled"])
        ]),
        body: _withCtx(({data: {name, ext, processing, failed}}) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_FileIcon, {
              ext: ext,
              error: failed,
              pulse: processing
            }, null, 8 /* PROPS */, ["ext", "error", "pulse"]),
            _createElementVNode("div", {
              class: _normalizeClass(["name ellipsed", {failed}])
            }, [
              _createVNode(_component_Highlight, {
                text: name,
                highlight: $props.highlight
              }, null, 8 /* PROPS */, ["text", "highlight"])
            ], 2 /* CLASS */)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "status",
        class: "content-width-col",
        sortable: "",
        "sort-field": "status"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "Status",
            sortable: "",
            "sort-order": sortOrder
          }, null, 8 /* PROPS */, ["sort-order"])
        ]),
        body: _withCtx(({data: {status, failed}}) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text", {failed}]),
            style: {"white-space":"nowrap"}
          }, [
            _createVNode(_component_StatusBadge, { status: status }, null, 8 /* PROPS */, ["status"])
          ], 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "size",
        class: "content-width-col",
        sortable: "",
        "sort-field": "size"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "Size",
            sortable: "",
            "sort-order": sortOrder
          }, null, 8 /* PROPS */, ["sort-order"])
        ]),
        body: _withCtx(({data: {size, failed}}) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text", {failed}]),
            style: {"white-space":"nowrap"}
          }, _toDisplayString(_ctx.$utils.format.bytes(size)), 3 /* TEXT, CLASS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "created_at",
        class: "content-width-col",
        sortable: "",
        "sort-field": "created_at"
      }, {
        sorticon: _withCtx(({sortOrder}) => [
          _createVNode(_component_TableHead, {
            name: "Date created",
            sortable: "",
            "sort-order": sortOrder
          }, null, 8 /* PROPS */, ["sort-order"])
        ]),
        body: _withCtx(({data: {created_at, failed}}) => [
          _createElementVNode("span", {
            class: _normalizeClass(["text", {failed}])
          }, _toDisplayString(_ctx.$utils.format.date(created_at)), 3 /* TEXT, CLASS */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, {
        field: "tags",
        class: "content-width-col"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_TableHead, { name: "Tags" })
        ]),
        body: _withCtx(({data: {tags}}) => [
          _createVNode(_component_TagsGroup, {
            highlight: $props.highlight,
            tags: tags || []
          }, null, 8 /* PROPS */, ["highlight", "tags"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Column, { class: "content-width-col" }, {
        body: _withCtx(({data: {id, status, task_id}}) => [
          _createElementVNode("div", _hoisted_4, [
            ((status === 'failed-processing' || status === 'processed' || status === 'uploaded'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_IconAsButton, {
                    icon: "refresh-cw-05",
                    onClick: $event => ($options.onResubmitTask(id))
                  }, null, 8 /* PROPS */, ["onClick"])
                ]))
              : _createCommentVNode("v-if", true),
            task_id
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_IconAsButton, {
                    icon: "clipboard",
                    onClick: $event => ($options.onCopyTaskResult(task_id))
                  }, null, 8 /* PROPS */, ["onClick"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_IconAsButton, {
                icon: "download-02",
                onClick: $event => ($options.onDownload(id))
              }, null, 8 /* PROPS */, ["onClick"])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["items", "total", "loading", "sort-field", "sort-order", "skip", "onPage", "onSort"]))
}